/* eslint-disable no-extra-boolean-cast */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export const localStorageCidClientKey = 'localStorageCidClientKey';
const clearOidcUser = () => {
    localStorage.removeItem(localStorageCidClientKey);
    Object.keys(localStorage).forEach((storageKey) => {
        if (storageKey.startsWith('oidc.user:')) {
            localStorage.removeItem(storageKey);
        }
    });
};
export default function useOneSessionClients() {
    const location = useLocation();
    useEffect(() => {
        if (location.pathname.endsWith('/login') && location.search) {
            const cidClient = new URLSearchParams(location.search).get('cid');
            if (!!cidClient) {
                localStorage.setItem(localStorageCidClientKey, '1');
            }
        }
        else if (!!localStorage.getItem(localStorageCidClientKey)) {
            window.addEventListener('beforeunload', clearOidcUser);
        }
        return () => {
            window.removeEventListener('beforeunload', clearOidcUser);
        };
    }, [location]);
}
